import React, { useEffect, useRef } from "react";
import styled from "styled-components";

export type Props = {
  className?: string;
  children: React.ReactNode;
  onClick: React.MouseEventHandler<HTMLElement>;
  mobile?: boolean;
};

const Mobile = styled.div`
  display: flex;
  height: 100%;
  pointer-events: none;
`;

const Desktop = styled.div``;

export const ClickAway: React.FC<Props> = ({ className, onClick, children, mobile = false }) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onClickOutside = (ev: MouseEvent): void => {
      if (ref.current?.contains(ev.target as HTMLElement)) {
        return;
      }

      // hack. this should really be `onClick(): void`

      setTimeout(() => onClick(ev as any as React.MouseEvent<HTMLElement>));
    };

    document.addEventListener("click", onClickOutside, { capture: true });

    return () => {
      document.removeEventListener("click", onClickOutside, { capture: true });
    };
  }, []);

  const Component = mobile ? Mobile : Desktop;

  return (
    <Component tabIndex={-1} className={className} ref={ref}>
      {children}
    </Component>
  );
};
